export function QuoteRequest() {
    return (
        <section className="bg-slate-50">
            <div className="mx-auto max-w-3xl px-6 py-20">
                <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-1.5 text-xs font-medium uppercase tracking-wider text-slate-600">
                    <span className="h-1.5 w-1.5 rounded-full bg-ptm-accent" />
                    Placeholder
                </div>
                <h1 className="text-4xl font-bold tracking-tight text-ptm-ink md:text-5xl">
                    Request a quote
                </h1>
                <p className="mt-4 max-w-2xl text-lg text-slate-600">
                    Upload your drawings or CAD models, tell us about your part, and we'll send back an
                    itemised quote. You can start a quote without an account — we'll verify your email
                    before the quote is issued.
                </p>

                <div className="mt-12 rounded-2xl border border-dashed border-slate-300 bg-white p-10 text-center shadow-sm">
                    <div className="text-sm font-semibold uppercase tracking-wider text-ptm-accent">
                        Coming soon
                    </div>
                    <h2 className="mt-3 text-2xl font-bold tracking-tight text-ptm-ink">
                        Quote request form under construction
                    </h2>
                    <p className="mx-auto mt-3 max-w-lg text-slate-600">
                        File upload, line-item entry, and email verification are being built. In the
                        meantime, email{' '}
                        <a
                            href="mailto:quotes@protomation.example"
                            className="font-semibold text-ptm-accent no-underline hover:underline"
                        >
                            quotes@protomation.example
                        </a>{' '}
                        with your drawings and we'll get back to you.
                    </p>
                </div>
            </div>
        </section>
    );
}
